import React, { useState, useEffect, useRef } from "react";
import { FaShareAlt, FaSave, FaArrowRight, FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/identitymodulenbg.jpeg";
// import backgroundMusic from "../../assets/music.mp3";

const textContent = [
  "High achievers don't wait for the future. They design it.",
  "🔹 Top executives shape their leadership identity before they step into it.",
  "🔹 Olympic athletes see the win before they take the shot.",
  "🔹 Innovative companies build leaders by thinking ahead.",
  "Your Future ID is more than an exercise. It's your vision made real.",
  "Why an ID Card? - Because clarity drives action!",
  "✅ Define who you want to be—your title, values, and mindset.",
  "✅ Set clear success markers—so you know when you've arrived.",
  "✅ Visualize key moments—and decide how you'll show up.",
  "✅ Stay motivated—with notes, reminders, and insights that keep you moving.",
];

const FutureIdCard = () => {
  const [visibleLines, setVisibleLines] = useState(textContent);

  const [showIdCard, setShowIdCard] = useState(false);
  const audioRef = useRef(null);
  const cursorRef = useRef(null);

  // Handle cursor movement
  useEffect(() => {
    const moveCursor = (e) => {
      if (cursorRef.current) {
        cursorRef.current.style.left = `${e.clientX}px`;
        cursorRef.current.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener("mousemove", moveCursor);
    return () => document.removeEventListener("mousemove", moveCursor);
  }, []);

  // useEffect(() => {
  //   let index = 0;
  //   const interval = setInterval(() => {
  //     setVisibleLines((prev) => {
  //       const newLines = [...prev];
  //       newLines[index] = textContent[index];
  //       return newLines;
  //     });

  //     index++;
  //     if (index === textContent.length) {
  //       clearInterval(interval);
  //       setTimeout(() => setShowIdCard(true), 1000);
  //     }
  //   }, 1000);

  //   // Play background music
  //   if (audioRef.current) {
  //     audioRef.current
  //       .play()
  //       .catch((error) => console.error("Autoplay blocked:", error));
  //   }

  //   return () => {
  //     clearInterval(interval);
  //     if (audioRef.current) {
  //       audioRef.current.pause();
  //       audioRef.current.currentTime = 0;
  //     }
  //   };
  // }, []);

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setVisibleLines((prev) => {
        const newLines = [...prev];
        newLines[index] = textContent[index];
        return newLines;
      });

      index++;
      if (index === textContent.length) {
        clearInterval(interval);
        setTimeout(() => setShowIdCard(true), 1000);
      }
    }, 1000);

    const audioElement = audioRef.current;

    // Play background music
    if (audioElement) {
      audioElement
        .play()
        .catch((error) => console.error("Autoplay blocked:", error));
    }

    return () => {
      clearInterval(interval);
      if (audioElement) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
    };
  }, []);

  useEffect(() => {
    const handleUserInteraction = () => {
      if (audioRef.current) {
        audioRef.current
          .play()
          .catch((error) => console.error("Playback failed:", error));
      }
      document.removeEventListener("click", handleUserInteraction);
    };

    document.addEventListener("click", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
    };
  }, []);

  return (
    <div style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div ref={cursorRef} className="custom-cursor" />
      {/* <audio ref={audioRef} loop>
        <source src={backgroundMusic} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio> */}
      <div className="container mx-auto max-h-screen w-full p-20 flex flex-row justify-center items-center gap-10">
        <div className="w-[50%] flex flex-col">
          <h1 className="text-3xl font-bold mb-6 text-black">My Future ID</h1>
          <h2 className="text-2xl font-semibold mb-6 text-gray-900">
            Your Future Starts Here
          </h2>
          <div>
            {visibleLines.map((line, index) => (
              <p
                key={index}
                className={`text-lg text-gray-800 font-normal mb-4 transition-opacity ${
                  line ? "opacity-100" : "opacity-0"
                }`}
              >
                {line}
              </p>
            ))}
          </div>
          <div className="mt-4 flex items-center gap-4">
            <Link
              to="/create-your-id-card"
              className="px-6 py-2 bg-orange-400 rounded-lg text-white font-bold shadow-md flex items-center gap-2 hover:bg-orange-500 transition duration-300"
            >
              Let's Begin
              <FaArrowRight className="text-white" />
            </Link>
          </div>
        </div>

        {showIdCard && (
          <div className="w-[50%] flex justify-center items-center p-4 animate-fadeIn">
            <div className="bg-white shadow-inner shadow-gray-500 border border-gray-300 rounded-2xl w-[60%]">
              {/* Profile Section */}
              <div
                className="relative flex items-center bg-gradient-to-tr from-slate-300 via-white to-slate-400 
p-3 rounded-t-2xl"
              >
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLXuM2b4djVbMt63hftHrWFFMeQmccyytKlQ&s"
                  alt="Profile"
                  className="w-36 h-48 object-cover rounded-2xl"
                />
                <div className="flex flex-col absolute bottom-4 left-40 justify-end pl-4">
                  <h2 className="text-lg text-black font-semibold">
                    Samantha Jones
                  </h2>
                  <p className="text-md text-gray-500">
                    Chief Technology Officer
                  </p>
                </div>
                <div className="absolute top-2 right-2 flex gap-2">
                  <button className="bg-white p-2 rounded-full shadow-md">
                    <FaShareAlt className="text-gray-600" />
                  </button>
                  <button className="bg-white p-2 rounded-full shadow-md">
                    <FaSave className="text-gray-600" />
                  </button>
                </div>
              </div>

              {/* Attributes Section */}
              <div className="bg-orange-400 text-white font-semibold text-md flex justify-center gap-2 py-2">
                <span>▫️ Integrity</span>
                <span>▫️ Empathy</span>
                <span>▫️ Leadership</span>
              </div>

              <div className="p-2">
                <div className="rounded-xl">
                  {/* Success Indicators */}
                  <div className="p-3 w-[95%] mx-auto">
                    <h3 className="text-md text-black font-semibold">
                      Success Indicators
                    </h3>
                    <p className="text-sm text-gray-700 mt-1">
                      Decision making at executive level - Growing expertise in
                      cyber security - Mentoring - Learning
                    </p>
                  </div>

                  {/* Traits Section */}
                  <div className="p-3 border-t border-gray-400 w-[95%] mx-auto">
                    <h3 className="text-md text-black font-semibold">Traits</h3>
                    <div className="flex gap-2 mt-2">
                      <span className="bg-orange-400 text-white text-sm px-3 py-1 rounded-md font-semibold">
                        Achievement
                      </span>
                      <span className="bg-orange-400 text-white text-sm px-3 py-1 rounded-md font-semibold">
                        Balance
                      </span>
                      <span className="bg-orange-400 text-white text-sm px-3 py-1 rounded-md font-semibold">
                        Creative
                      </span>
                    </div>
                  </div>

                  {/* Quote Section */}
                  <div className="p-3 border-t border-gray-400 w-[95%] mx-auto">
                    <div className="text-md italic text-gray-700">
                      "It’s not about ideas. It’s about making ideas happen." –
                      Scott Belsky
                    </div>
                  </div>

                  {/* Audio Section at Bottom with Proper Spacing */}
                  <div className="p-3 rounded-b-xl">
                    <div className="w-[95%] mx-auto bg-orange-100 p-3 flex items-center gap-4 rounded-xl shadow-md">
                      {/* Play Button */}
                      <button className="w-12 h-12 text-black text-xl flex items-center justify-center rounded-full">
                        <FaPlay />
                      </button>

                      {/* Waveform Visualiz;ation (Placeholder for actual waveform animation) */}
                      <div className="flex-1 flex items-center gap-1">
                        {[...Array(20)].map((_, i) => (
                          <div
                            key={i}
                            className="w-1 bg-gray-700 rounded-full"
                            style={{ height: `${Math.random() * 20 + 10}px` }}
                          ></div>
                        ))}
                      </div>

                      {/* Profile Image */}
                      <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLXuM2b4djVbMt63hftHrWFFMeQmccyytKlQ&s"
                        alt="User"
                        className="w-12 h-12 rounded-full object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FutureIdCard;
